import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {getUrlParameters} from '../../common/util/urlParameters';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {loadAccessoriesOrders} from './orders';

export const fetchTechnicians = (params = {}) =>
  apiActionCreator({
    'endpoint': `/accessories/technicians${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_TECHNICIANS,
      ActionTypes.FETCHED_TECHNICIANS,
      [
        ActionTypes.FETCHED_TECHNICIANS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchTasksByOrder = (order, params = {}) =>
  apiActionCreator({
    'endpoint': `/accessories/orders/${order}/tasks${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_TASKS_BY_ORDER,
      ActionTypes.FETCHED_TASKS_BY_ORDER,
      [
        ActionTypes.FETCHED_TASKS_BY_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const addTechniciansToTasksByOrder =
  (order, tasks, accessoriesData) => (dispatch) => {
    return dispatch(
      apiActionCreator({
        'endpoint': `/accessories/orders/${order}/tasks`,
        'authenticated': true,
        'types': [
          ActionTypes.ADDING_TECHNICIANS_TO_TASKS_BY_ORDER,
          [
            () => {
              dispatch(loadAccessoriesOrders(accessoriesData, false));
              return {'type': ActionTypes.ADDED_TECHNICIANS_TO_TASKS_BY_ORDER};
            },
            MessageActions.addMessageBoxInfo(
              'Técnicos asignados satisfactoriamente'
            ),
          ],
          [
            ActionTypes.ADDED_TECHNICIANS_TO_TASKS_BY_ORDER_FAILED,
            (error) => buildErrorMessage(error),
          ],
        ],
        'microservice': 'part',
        'method': 'POST',
        'contentType': 'application/json',
        'data': tasks,
      })
    );
  };
